import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TenderCard from "./TenderCard";
import ButtonPrev from "../../ui/ButtonPrev";
import ButtonNext from "../../ui/ButtonNext";
import tenderData from "../../utils/tenderData";
import PopupForm from "../../ui/PopupForm";

function TenderContent() {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : tenderData.length - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < tenderData.length - 1 ? prevIndex + 1 : 0
    );
  };

  const openPopup = (content) => {
    setPopupContent(content);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContent(null);
  };

  return (
    <div className="text-center mb-28 mt-20">
      <h2 className="text-5xl xl:text-5xl xxs:text-4xl font-bold text-green-900">
        {t("TenderContent.tenderTitle")}
      </h2>

      <div className="mt-24 text-start">
        <TenderCard
          title={tenderData[currentIndex].title}
          description={tenderData[currentIndex].description}
          onMoreDetails={() =>
            openPopup(
              <div>
                <h2 className="text-3xl font-bold text-green-800">
                  {tenderData[currentIndex].title}
                </h2>
                <p className="text-gray-700 text-base mt-4">
                  {tenderData[currentIndex].description}
                </p>
                <p className="mt-4 text-sm text-green-700">
                  Additional Information for {tenderData[currentIndex].title}.
                </p>
              </div>
            )
          }
        />
      </div>

      <div className="mt-8 flex justify-between items-center px-6">
        <div className="flex space-x-12">
          <ButtonPrev
            onClick={handlePrev}
            className="shadow-lg hover:shadow-xl transition-shadow duration-300"
          />
          <ButtonNext
            onClick={handleNext}
            className="shadow-lg hover:shadow-xl transition-shadow duration-300"
          />
        </div>

        <div className="flex space-x-2 mt-10">
          {tenderData.map((_, index) => (
            <button
              key={index}
              className={`w-4 h-4 rounded-full ${
                index === currentIndex ? "bg-green-900" : "bg-green-600"
              } shadow-md hover:shadow-lg transition-shadow duration-300`}
              onClick={() => setCurrentIndex(index)}
            ></button>
          ))}
        </div>
      </div>

      {/* Popup Component */}
      <PopupForm isOpen={isPopupOpen} onClose={closePopup}>
        {popupContent}
      </PopupForm>
    </div>
  );
}

export default TenderContent;
